"use strict";
/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/noop.js
 ** module id = 142
 ** module chunks = 0
 **/